export default __webpack_public_path__ + "static/media/CNo.61-2.333d1ac4.jpg";